<template>
	<div class="tag-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{ fuwuInfo.title || '' }}</div>
				<!-- <div class="des">运输仓储到使用废弃全生命周期碳排放数据的绿色标识，让抽象的 “碳足迹” 变得直观可感</div> -->
				<div class="btns">
					<el-button class="lijishiyong" type="whitetrans" @click="apply"
						>立即申请</el-button
					>
				</div>
			</div>
		</div>
		<!-- 服务介绍 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="serviceIntroduce">
				<div class="serviceIntroduce-container w1200">
					<div class="heading">服务介绍</div>
					<div class="heading-des">
						基于产品碳足迹核查结果，依据T/CCIASD10016—2025《集装箱产品碳足迹标签评价技术规范》发放集装箱产品碳足迹标签，实现集装箱产品碳标签的申请、审核、编码发放以及标签图形自动生成等功能，展示集装箱产品碳足迹数值和产品碳足迹等级，构造碳标签溯源体系，实现“一品一码、一码溯源”。
					</div>
				</div>
			</div>
		</div>
		<!-- 步骤 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="steps">
				<div class="steps-container w1200">
					<div class="heading">集装箱产品碳标签申请流程</div>
					<!-- <div class="heading-des">
						通过碳核算，组织可以更好地了解和管理其碳足迹，制定减排战略和行动计划
						<br />
						以达到减少温室气体排放的目标，促进可持续发展和应对气候变化
					</div> -->
					<div class="list">
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">企业申请碳标签</div>
							<!-- <div class="des">企业填报核算相关基础数据、选择碳排因子等</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">提交产品碳足迹核算报告</div>
							<!-- <div class="des">测量和计算特定产品碳足迹</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">平台审核</div>
							<!-- <div class="des">收集和整理与活动相关的数据，包括能源使用、运输、原材料采购等，用于计算碳排放</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">发放产品碳标签</div>
							<!-- <div class="des">生成碳足迹报告，详细说明排放数据、计算方法和数据来源，向利益相关者和公众披露</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">企业自行下载碳标签</div>
							<!-- <div class="des">根据需要选择第三方机构</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 标签示例 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="tagExample">
				<div class="heading">集装箱产品碳标签示例</div>
				<div class="tagExample-container w1200">
					<div class="left-block">
						<div class="item">
							<div class="label">1.集装箱产品碳排放量数值</div>
							<div class="des">公开集装箱产品生命周期内的碳排放量。</div>
						</div>
						<div class="item">
							<div class="label">2.集装箱产品碳排放水平</div>
							<div class="des">
								碳足迹标签等级分为★★★★★级、★★★★级和★★★级和基本级四个等级，其中★★★★★级<br />碳足迹标签的碳足迹数值最低，基本级碳足迹标签的碳足迹数值最高。
							</div>
						</div>
						<div class="item">
							<div class="label">3.标签溯源二维码</div>
							<div class="des">
								集装箱产品碳足迹标签通过标签上的二维码进行信息溯源。集装箱产品碳足迹标签至少应追溯以下信息：<br />
								a.产品信息：产品名称、规格型号；<br />
								b.委托人信息：委托人名称、地址；<br />
								c.生产者信息：生产者名称、地址；<br />
								d.生产企业信息：生产企业名称、地址；<br />
								e.碳足迹评价信息：碳足迹量化依据的标准、系统边界、声明单位、数据统计期、碳足迹数值等；<br />
								f.评价机构信息：评价机构名称、发证时间。
							</div>
						</div>
					</div>
					<div class="example-img">
						<img class="img" src="@/assets/svgs/tag.svg" alt="" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="false" class="main">
			<div class="main-container w1260">
				<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
					<div class="features">
						<div class="item">
							<svg-icon name="aixin"></svg-icon>
							<div class="content">
								<div class="label">信息透明化</div>
								<div class="value">
									清晰呈现产品碳排放数据，消除环保宣传信息差，让消费者快速获取真实环境影响信息
								</div>
							</div>
						</div>
						<div class="item">
							<svg-icon name="shandian"></svg-icon>
							<div class="content">
								<div class="label">追溯可量化</div>
								<div class="value">
									依托全生命周期核算标准，精准追溯碳排放关键环节，为企业减排提供数据支撑
								</div>
							</div>
						</div>
						<div class="item">
							<svg-icon name="bi"></svg-icon>
							<div class="content">
								<div class="label">等级标准化</div>
								<div class="value">
									以统一标准划分碳足迹等级，直观展示产品碳足迹在行业内所处水平
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
					<div class="section-1">
						<div class="left-module">
							<div class="heading">对企业的核心价值</div>
							<div class="heading-des">
								是连接企业绿色生产与消费者低碳消费的重要桥梁
							</div>
							<div class="list">
								<div class="item">
									<div class="serial">1</div>
									<div class="content">
										<div class="label">彰显责任担当</div>
										<div class="value">
											主动公开碳排放数据，传递绿色生产理念，强化品牌环保形象与社会信任度
										</div>
									</div>
								</div>
								<div class="item">
									<div class="serial">2</div>
									<div class="content">
										<div class="label">提升市场竞争力</div>
										<div class="value">
											满足消费者低碳需求，适配绿色采购政策，开拓低碳产品细分市场
										</div>
									</div>
								</div>
								<div class="item">
									<div class="serial">3</div>
									<div class="content">
										<div class="label">驱动降本增效</div>
										<div class="value">
											通过碳标签背后的核算数据，定位高排放环节，优化生产工艺实现节能减碳
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="right-module scale-img">
							<img class="img" src="@/assets/tmp/028.png" alt="" />
						</div>
					</div>
				</div>
				<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
					<div class="section-2">
						<div class="left-module scale-img">
							<img class="img" src="@/assets/tmp/029.png" alt="" />
						</div>
						<div class="right-module">
							<div class="heading">对企业客户的实用意义</div>
							<div class="list">
								<div class="item">
									<div class="serial">01.</div>
									<div class="label">增强市场竞争力</div>
									<div class="value">
										碳标签是企业低碳实力的可视化证明，能契合下游客户（尤其是跨国企业、政府机构）的绿色采购需求。帮助企业在同质化竞争中脱颖而出，积累绿色品牌口碑，拓展高价值市场渠道
									</div>
								</div>
								<div class="item">
									<div class="serial">02.</div>
									<div class="label">提前适配合规要求</div>
									<div class="value">
										全球多地已出台碳足迹披露、碳关税等政策，碳标签对应的核算数据可直接支撑合规申报。避免因未满足低碳标准被排除在供应链之外，降低政策变动带来的经营不确定性
									</div>
								</div>
								<div class="item">
									<div class="serial">03.</div>
									<div class="label">优化内部运营</div>
									<div class="value">
										碳标签核算过程能精准定位产品全生命周期的高能耗环节，为节能改造提供明确方向。通过优化能源使用、减少碳排放，可同步降低电费、原材料消耗等成本，提升盈利空间
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { webInfo } from '@/common/data.js'
import Head from '@/layout/Head/Head.vue'
import Foot from '@/layout/Foot/Foot.vue'
import { WOW } from 'wowjs'
export default {
	name: 'tag',
	components: { Head, Foot },
	data() {
		return {
			fuwuInfo: webInfo.sidafuwu[2]
		}
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init()
		})
	},
	methods: {
		backHead() {
			this.$router.go(-1)
		},
		apply() {
			if (this.checkUser()) {
				if (this.uInfo && this.uInfo.roles && this.uInfo.certifiedStatus == '2') {
					if (this.uInfo.isAdmin) {
						window.open('/org/home/#/enterprise/footprint', '_self')
						// } else if (
						// 	(!this.uInfo.isAdmin &&
						// 		this.uInfo.roles &&
						// 		(this.uInfo.roles.indexOf('manager') != -1 ||
						// 			this.uInfo.username.indexOf('AdminMaster01') != -1 ||
						// 			this.uInfo.username.indexOf('AdminMaster02') != -1)) ||
						// 	this.uInfo.roles.indexOf('manager_userSet') != -1
						// ) {
						// 	window.open('/org/admin/', '_self');
						// } else if (!this.uInfo.isAdmin && this.uInfo.roles && this.uInfo.roles.indexOf('government') != -1) {
						// 	window.open('/org/admin/', '_self');
						// } else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('authentication') != -1 || this.uInfo.roles.indexOf('auth_userSet') != -1)) {
						// 	window.open('/org/authority/', '_self');
					} else if (
						!this.uInfo.isAdmin &&
						this.uInfo.roles &&
						(this.uInfo.roles.indexOf('company') != -1 ||
							this.uInfo.roles.indexOf('home_userSet') != -1)
					) {
						window.open('/org/home/#/enterprise/footprint', '_self')
					} else {
						this.toast({
							type: 'warning',
							message: '暂无进入企业端角色权限，请联系管理员'
						})
					}
				} else if (this.uInfo && this.uInfo.certifiedStatus) {
					if (this.uInfo.certifiedStatus == 1) {
						this.toast({
							type: 'warning',
							message: '实名审核中，请等待审核结果'
						})
					} else if (this.uInfo.certifiedStatus == 2) {
						this.toast({
							type: 'warning',
							message: '暂无进入工作台角色权限，请联系管理员'
						})
					} else if (this.uInfo.certifiedStatus == 3) {
						this.toast({
							type: 'warning',
							message: '实名失败，请重新提交'
						})
					}
				}
			} else {
				this.toast({
					type: 'warning',
					message: '请先登录'
				})
				this.$router.push({
					name: 'login'
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.tag-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/027.png');
		background-size: cover;
		height: 334px;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 93px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
			}
			.btns {
				margin-top: 40px;
				display: flex;
				.lijishiyong {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					width: 160px;
					height: 50px;
					border-radius: 0px;
					// font-weight: bold;
					font-size: 16px;
					line-height: 22px;
				}
			}
		}
	}
	.serviceIntroduce {
		background: #f6f8fc;
		padding-bottom: 45px;
		.serviceIntroduce-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				width: 1097px;
				line-height: 30px;
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				text-align: justify;
				text-align-last: center;
			}
		}
	}
	.steps {
		.steps-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.list {
				align-self: stretch;
				margin-top: 56px;
				margin-bottom: 45px;
				display: flex;
				.item {
					// width: 215px;
					flex: 1;
					padding-left: 15px;
					padding-right: 15px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.svg-tianbao {
						width: 70px;
						height: 70px;
					}
					.label {
						margin-top: 27px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
						text-align: center;
					}
					.des {
						margin-top: 20px;
						font-size: 14px;
						color: #636d7e;
						line-height: 20px;
						text-align: justify;
						text-align-last: center;
					}
				}
			}
		}
	}
	.tagExample {
		background: #F9FAFB;
		padding-top: 40px;
		padding-bottom: 110px;
		.heading {
			margin-bottom: 40px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 28px;
			color: #000000;
			line-height: 52px;
			text-align: center;
		}
		.tagExample-container {
			display: flex;
			align-items: center;
			background: #FFFFFF;
			padding-bottom: 20px;
			
			.heading-des {
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.left-block {
				display: flex;
				flex-direction: column;
				margin-left: 28px;
				margin-right: auto;
				.item {
					margin-top: 30px;
					display: flex;
					flex-direction: column;
					.label {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 19px;
						color: #262729;
					}
					.des {
						margin-top: 10px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: rgba(#262729,0.7);
					}
				}
			}
			.example-img {
				display: flex;
				margin-left: auto;
				margin-right: 78px;
				.img {
					width: 278px;
					height: 278px;
				}
			}
		}
	}
	.main {
		.main-container {
			display: flex;
			flex-direction: column;
			.features {
				display: flex;
				justify-content: space-between;
				border-bottom: 1px dashed rgba(#080a52, 0.2);
				.item {
					display: flex;
					padding: 68px 0;
					.svg-icon {
						margin-top: 13px;
						margin-right: 37px;
						width: 80px;
						height: 80px;
					}
					.content {
						display: flex;
						flex-direction: column;
						width: 292px;
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 24px;
							color: #262729;
							line-height: 33px;
						}
						.value {
							margin-top: 17px;
							font-size: 14px;
							color: #636d7e;
							line-height: 20px;
						}
					}
				}
			}
			.section-1 {
				display: flex;
				padding-bottom: 96px;
				.left-module {
					display: flex;
					flex-direction: column;
					flex: 1;
					padding-right: 36px;
					.heading {
						margin-top: 53px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 28px;
						color: #000000;
						line-height: 52px;
					}
					.heading-des {
						margin-top: 22px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 17px;
						color: rgba(#262729, 0.7);
						line-height: 24px;
					}
					.list {
						margin-top: 81px;
						display: flex;
						flex-direction: column;
						.item {
							margin-bottom: 40px;
							display: flex;
							&:last-child {
								margin-bottom: 0;
							}
							.serial {
								margin-right: 23px;
								margin-top: 7px;
								width: 40px;
								height: 40px;
								background: #2d947a;
								border-radius: 50%;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 23px;
								color: #ffffff;
								line-height: 40px;
								text-align: center;
							}
							.content {
								flex: 1;
								display: flex;
								flex-direction: column;
								.label {
									font-family: PingFangSC, PingFang SC;
									font-weight: 500;
									font-size: 21px;
									color: #262729;
									line-height: 29px;
								}
								.value {
									margin-top: 8px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 500;
									font-size: 15px;
									color: rgba(#262729, 0.7);
									line-height: 21px;
								}
							}
						}
					}
				}
				.right-module {
					margin-top: 91px;
					border-radius: 20px;
					img {
						width: 599px;
						height: 425px;
						border-radius: 20px;
					}
				}
			}
			.section-2 {
				display: flex;
				padding-bottom: 80px;
				.left-module {
					border-radius: 20px;
					img {
						width: 485px;
						height: 577px;
						border-radius: 20px;
					}
				}
				.right-module {
					display: flex;
					flex-direction: column;
					flex: 1;
					padding-left: 36px;
					.heading {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 28px;
						color: #000000;
						line-height: 52px;
					}
					.list {
						margin-top: 35px;
						display: flex;
						flex-direction: column;
						.item {
							height: 156px;
							display: flex;
							padding-top: 46px;
							box-sizing: border-box;
							border-bottom: 1px solid rgba(#080a52, 0.1);
							.serial {
								width: 78px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 28px;
								color: #29965c;
								line-height: 40px;
							}
							.label {
								width: 244px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 26px;
								color: #1d263a;
								line-height: 37px;
							}
							.value {
								flex: 1;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 17px;
								color: rgba(#262729, 0.7);
								line-height: 24px;
								text-align: justify;
							}
						}
					}
				}
			}
		}
	}
}
</style>
